<div class="action-btns">
  <p-menu #menu [popup]="true" [model]="actionManager().menuConfigs" appendTo="body">
    <ng-template let-item pTemplate="item">
      <li pMenuItem (click)="item.execute(entity(), actionExecuted)">
        <a [attr.aria-label]="item.config.label" class="p-ripple p-element p-menuitem-link">
          <span [class]="item.config.icon" class="p-menuitem-icon"></span>
          <span class="p-menuitem-text">{{ item.config.label | translate }}</span>
        </a>
      </li>
    </ng-template>
  </p-menu>
  <p-button (onClick)="menu.toggle($event)" icon="pi pi-ellipsis-v" [text]="true" severity="secondary" />
</div>
